import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AvatarsStyleModal extends Component {
  render() {
    var { onChange, selected } = this.props;
    return (
      <div>
        <div className="figures">
          <div className="figure">
            <img
              className="avatars-image"
              src="https://publisher-assets.spot.im/host-panel/avatars_style_colorful.png"
            />
            <div className="option-title">Colorful Scheme</div>
            <div className="label">Guests will get random avatars, colors and usernames.</div>
            <div className="button-wrapper">
              <button
                onClick={onChange.bind(this, 'colorful')}
                className="select-button"
                disabled={selected === 'colorful'}
              >
                {selected === 'colorful' ? 'Selected' : 'Select'}
              </button>
            </div>
          </div>
          <div className="figure">
            <img
              className="avatars-image"
              src="https://publisher-assets.spot.im/host-panel/avatars_style_grey.png"
            />
            <div className="option-title">Grey Scheme</div>
            <div className="label">Guests will get random avatars and usernames.</div>
            <div className="button-wrapper">
              <button
                onClick={onChange.bind(this, 'gray')}
                className="select-button"
                disabled={selected === 'gray'}
              >
                {selected === 'gray' ? 'Selected' : 'Select'}
              </button>
            </div>
          </div>
          <div className="figure">
            <img
              className="avatars-image"
              src="https://publisher-assets.spot.im/host-panel/avatars_style_traditional.png"
            />
            <div className="option-title">Traditional</div>
            <div className="label">Guests will get identical avatars in conversations.</div>
            <div className="button-wrapper">
              <button
                onClick={onChange.bind(this, 'traditional')}
                className="select-button"
                disabled={selected === 'traditional'}
              >
                {selected === 'traditional' ? 'Selected' : 'Select'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AvatarsStyleModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired
};

AvatarsStyleModal.displayName = 'AvatarsStyleModal';

export default AvatarsStyleModal;
